<template>
    <section class="testimonial py-5" id="activityRegist">
        <div class="container">
            <div class="row ">
                <div class="col-12 py-5 border text-center">
                    <h4 class="pb-4">활동 {{$route.params.id ? '수정' : '등록'}} </h4>
                    <form>
                        <div class=" ">
                            <div class="card-body">
                                <img v-if="activity.thumbnail" :src="activity.thumbnail" class="img-thumbnail img-responsive" />
                                <h2 class="py-3">대표 사진</h2>
                                <p>
                                    대표이미지 (정사각형, 800px*800px)
                                </p>
                                <!--<button v-if="activity.thumbnail" @click="removeImage">Remove image</button>-->
                                <input type="file" ref="thumbnail" @change="onFileChange" multiple />
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="form-group col-md-2">
                                활동명
                            </div>
                            <div class="form-group col-md-10">
                                <input v-model="activity.title" placeholder="활동명을 입력해주세요." class="form-control"
                                       type="text">
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-2">
                                시작일
                            </div>
                            <div class="form-group col-md-4">
                                <div class='input-group date' id='datetimepicker1'>
                                    <datePicker name="activityStartDate" placeHolder="시작일" ref="activityStartDate"
                                                v-model="activity.activityStartDate" :config="options"></datePicker>
                                    <span class="input-group-addon">
                                        <span class="fa fa-calendar btn" ></span>
                                    </span>
                                </div>


                            </div>
                            <div class="form-group col-md-2">
                                종료일
                            </div>
                            <div class="form-group col-md-4">
                                <div class='input-group date' id='datetimepicker2'>
                                    <datePicker name="activityEndDate" placeHolder="종료일" v-model="activity.activityEndDate"
                                            :config="options"></datePicker>
                                    <span class="input-group-addon">
                                        <span class="fa fa-calendar btn"></span>
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="form-group col-md-2">
                                접수마감
                            </div>
                            <div class="form-group col-md-4">
                                <div class='input-group date' id='datetimepicker3'>
                                    <datePicker name="joinDueDate" placeHolder="접수 마감일" v-model="activity.joinDueDate"
                                            :config="options"></datePicker>
                                    <span class="input-group-addon">
                                        <span class="fa fa-calendar btn"></span>
                                    </span>
                                </div>
                            </div>
                            <div class="form-group col-md-2">
                                모집인원
                            </div>
                            <div class="form-group input-group col-md-4">
                                <input v-model="activity.joinAblePersonCount" placeholder="최대 모집 인원" class="form-control"
                                       required="required" type="number" aria-describedby="basic-addon11">
                                <div class="input-group-append">
                                    <span class="input-group-text" id="basic-addon11">명</span>
                                </div>
                            </div>

                        </div>

                        <div class="form-row">
                            <div class="form-group col-md-2">
                                카테고리
                            </div>
                            <div class="form-group col-md-4">
                                <select v-model="activity.category" class="form-control">
                                    <!--<option selected="selected">선택하세요</option>-->
                                    <option v-bind:value="c.code" v-for="c in $root.$children[0].category">{{c.name}}
                                    </option>
                                </select>
                            </div>

                            <div class="form-group col-md-2">
                                세부분류
                            </div>
                            <div class="form-group input-group col-md-4">
                                <input v-model="activity.categorySub" placeholder="세부 카테고리" class="form-control"
                                       required="required" type="text" >
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="form-group col-md-2">
                                봉사시간
                            </div>
                            <div class="form-group input-group col-md-4">
                                <input placeholder="시간" class="form-control" v-model="activity.volunteerHour" type="number" aria-describedby="basic-addon0">
                                <div class="input-group-append">
                                    <span class="input-group-text" id="basic-addon0">시간</span>
                                </div>
                                <input v-model="activity.volunteerMinute" placeholder="봉사시간" class="form-control"
                                       required="required" type="number" aria-describedby="basic-addon1">
                                <div class="input-group-append">
                                    <span class="input-group-text" id="basic-addon1">분</span>
                                </div>
                            </div>
                            <div class="form-group col-md-2">
                                비용
                            </div>
                            <div class="form-group input-group col-md-4">
                                <input v-model="activity.activityJoinCost" placeholder="비용" class="form-control"
                                       required="required" type="number" aria-describedby="basic-addon2">
                                <div class="input-group-append">
                                    <span class="input-group-text" id="basic-addon2">원</span>
                                </div>
                            </div>
                        </div>
                        <div class="form-row" v-if="activity.activityJoinCost > 0">

                            <div class="form-group col-md-2">
                                비용 입금 계좌 정보
                            </div>
                            <div class="form-group input-group col-md-10">
                                <div class="input-group-preppend">
                                    <span class="input-group-text" id="basic-addon22">계좌번호 은행 예금주(형식 자유)</span>
                                </div>
                                <input v-model="activity.activityCostAccountInfo" placeholder="000-0000-00000 카라은행 홍길동" class="form-control"
                                       required="required" type="text" aria-describedby="basic-addon22">
                            </div>

                        </div>

                        <div class="form-row">
                            <div class="form-group col-md-2">
                                레벨제한
                            </div>
                            <div class="form-group col-md-4 input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">Lv</span>
                                </div>
                                <input v-model="activity.minJoinLimitByLevel" placeholder="레벨최소" max="10" class="form-control" required="required" type="number" aria-describedby="basic-addon3" @blur="levelCheck">
                                <div class="input-group-append">
                                    <span class="input-group-text" id="basic-addon3">부터</span>
                                </div>
                            </div>
                            <div class="form-group col-md-2">
                                <div class="form-check">
                                    <input class="form-check-input" @click="setDefaultLevelToggle"
                                           :checked="(activity.minJoinLimitByLevel == 0 && activity.maxJoinLimitByLevel == 10)" type="checkbox">
                                    <label class="form-check-label" >
                                        <small>제한없음</small>
                                    </label>
                                </div>
                            </div>
                            <div class="form-group col-md-4 input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">Lv</span>
                                </div>
                                <input v-model="activity.maxJoinLimitByLevel" max="10" placeholder="레벨최대" class="form-control" required="required" type="number" aria-describedby="basic-addon4" @blur="levelCheck">
                                <div class="input-group-append">
                                    <span class="input-group-text" id="basic-addon4">까지</span>
                                </div>
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="form-group col-md-2">
                                나이제한
                            </div>
                            <div class="form-group col-md-4 input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">만</span>
                                </div>
                                <input v-model="activity.minJoinLimitByAge" placeholder="나이최소" max="100" class="form-control" required="required" type="number" aria-describedby="basic-addon5" @change="ageCheck">
                                <div class="input-group-append">
                                    <span class="input-group-text" id="basic-addon5">세 부터</span>
                                </div>
                            </div>
                            <div class="form-group col-md-2">
                                <div class="form-check">
                                    <input class="form-check-input" @click="setDefaultAgeToggle"
                                           :checked="(activity.minJoinLimitByAge == 0 && activity.maxJoinLimitByAge == 100)" type="checkbox">
                                    <label class="form-check-label" >
                                        <small>제한없음</small>
                                    </label>
                                </div>
                            </div>
                            <div class="form-group col-md-4 input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">만</span>
                                </div>
                                <input v-model="activity.maxJoinLimitByAge" placeholder="나이최대" max="100" class="form-control" required="required" type="number" aria-describedby="basic-addon6" @change="ageCheck">
                                <div class="input-group-append">
                                    <span class="input-group-text" id="basic-addon6">세 까지</span>
                                </div>
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="form-group col-md-2 col-sm-2">
                                장소 주소
                            </div>
                            <div class="form-group col-md-4 col-sm-4">
                                <input v-model="activity.activityPlaceAddress" readonly="readonly"  @click="popupPostcode" placeholder="주소를 검색해주세요."
                                       class="form-control" required="required" type="text">

                            </div>
                            <div class="form-group col-md-2 col-sm-2">
                                장소명
                            </div>
                            <div class="form-group col-md-4 col-sm-4">
                                <input v-model="activity.activityPlaceName" placeholder="더봄센터" class="form-control"
                                       required="required" type="text">
                            </div>
                        </div>


                        <div class="form-row">
                            <div class="form-group col-md-2">
                                태그
                            </div>
                            <div class="form-group col-md-10 input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">#</span>
                                </div>
                                <input v-model="activity.activityTags" placeholder="#더배움 #산업동물, 액티비티 연관 검색, 주제 기록"
                                       class="form-control" required="required" type="text">
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-2">
                                유의사항
                            </div>
                            <div class="form-group col-md-10 input-group">
                                <div class="input-group-prepend d-none">
                                    <span class="input-group-text">필요자격 및 <br> 사고발생 시<br> 책임안내 등</span>
                                </div>
                                <textarea v-model="activity.activityNotice" name="activityNotice" cols="40" rows="5"
                                          class="form-control"></textarea>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-2">
                                신청/취소안내
                            </div>
                            <div class="form-group col-md-10 input-group">
                                <div class="input-group-prepend d-none">
                                    <span class="input-group-text">신청/취소안내<br> (패널티 안내)</span>
                                </div>
                                <textarea v-model="activity.activityCancelPenaltyNotice"
                                          name="activityCancelPenaltyNotice" cols="40" rows="5"
                                          class="form-control"></textarea>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-2">
                                상세정보 <br>(사진, 글 에디터)
                            </div>

                            <quill-editor style="height: 450px" ref="activityDetails" v-model="activity.activityDetails"
                                          :content="activity.activityDetails"
                                          :options="editorOption"
                                          @change="onEditorChange($event)"
                                          name="activityDetails" class="form-group col-md-10 quill-editor ">
                            </quill-editor>

                        </div>

                        <div class="form-row">
                            <div class="form-group col-md-2">
                            </div>
                            <div class="form-group">
                                <div class="form-check">
                                    <input class="form-check-input" v-model="activity.activityJoinAbleNow"
                                           type="checkbox" value="" id="activityJoinAbleNow" required>
                                    <label class="form-check-label" for="activityJoinAbleNow">
                                        <small>신청가능한 활동입니다. (단체봉사, 수의료 봉사, 찾아가는 교육은 보여지지만 전화 신청)</small>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-2">
                            </div>
                            <div class="form-group">
                                <div class="form-check">
                                    <input class="form-check-input" v-model="activity.visibleAddressToJoinerOnly"
                                           type="checkbox" value="" id="visibleAddressToJoinerOnly" required>
                                    <label class="form-check-label" for="visibleAddressToJoinerOnly">
                                        <small>신청자에게만 주소를 공개합니다. (체크시 리스트에서는 공개되지 않음)</small>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="form-group col-md-2">
                            </div>
                            <div class="form-group">
                                <div class="form-check">
                                    <input class="form-check-input" v-model="activity.karaRegularMemberOnly"
                                           type="checkbox" value="" id="karaRegularMemberOnly" required>
                                    <label class="form-check-label" for="karaRegularMemberOnly">
                                        <small>카라 정기 회원만 신청가능한 활동입니다. </small>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="form-group col-md-2">
                            </div>
                            <div class="form-group">
                                <div class="form-check">
                                    <input class="form-check-input" v-model="activity.isRepeatableDayOfWeek"
                                           type="checkbox" value="" id="isRepeatableDayOfWeek" required>
                                    <label class="form-check-label" for="isRepeatableDayOfWeek">
                                        <small>요일반복으로 신청가능한 활동입니다. </small>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="form-group col-md-2">
                            </div>
                            <div class="form-group">
                                <div class="form-check">
                                    <input class="form-check-input" v-model="activity.isFixedTop"
                                           type="checkbox" value="" id="isFixedTop" required>
                                    <label class="form-check-label" for="isFixedTop">
                                        <small>활동을 메인상단에 고정합니다. </small>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div class="form-row" v-if="false">
                            <div class="form-group col-md-2">
                            </div>
                            <div class="form-group">
                                <div class="form-check">
                                    <input class="form-check-input" v-model="activity.disableAppliedLunchbox"
                                           type="checkbox" value="" id="disableAppliedLunchbox" required>
                                    <label class="form-check-label" for="disableAppliedLunchbox">
                                        <small>도시락 제공 메뉴를 숨깁니다. </small>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="form-group col-md-2">
                            </div>
                            <button type="button" v-on:click="formSubmit()" class="btn btn-danger">{{$route.params.id ? '수정' : '등록'}}하기</button>
                            <button v-if="$route.params.id" type="button" v-on:click="deleteActivity()" class="btn btn-warning" style="margin-left:10px;">삭제</button>
                        </div>
                    </form>
                </div>
            </div>


        </div>
        <modals-container @before-close="getAddress" />
        <vue-daum-map
                :appKey="appKey"
                :center.sync="center"
                :level.sync="level"
                :mapTypeId="mapTypeId"
                :libraries="libraries"
                @load="onLoad"
                style="width:0px;height:0px;"/>
       <!-- @center_changed=""
        @zoom_start=""
        @zoom_changed=""
        @bounds_changed=""
        @click=""
        @dblclick=""
        @rightclick=""
        @mousemove=""
        @dragstart=""
        @drag=""
        @dragend=""
        @idle=""
        @tilesloaded=""
        @maptypeid_changed=""-->
    </section>
</template>
<script>
    import VueDaumMap from 'vue-daum-map';

    import moment from 'moment';
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
import datePicker from 'vue-bootstrap-datetimepicker';


    import Postcode from '@/components/Postcode.vue';

    import 'quill/dist/quill.bubble.css';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';

    import { quillEditor } from 'vue-quill-editor';

    import Quill from 'quill';

    import ImageResize from 'quill-image-resize-module';
import imageUpload from 'quill-plugin-image-upload';

    Quill.register('modules/imageUpload', imageUpload)
    Quill.register('modules/imageResize', ImageResize)

    export default {
        name: 'activityRegist',
        components: {
            datePicker, quillEditor, Postcode, VueDaumMap
        },
        data() {
            return {
                editorOption: {
                    modules: {
                        toolbar: [
                            [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
                            ['bold', 'italic'],
                            [{'list': 'ordered'}, {'list': 'bullet'}],
                            ['link', 'image', 'video'],
                            [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
                            [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
                            [{ 'direction': 'rtl' }],                         // text direction

                            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

                            [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
                            [{ 'font': [] }],
                            [{ 'align': [] }],

                            ['clean']                                         // remove formatting button
                        ],
                        history: {
                            delay: 1000,
                            maxStack: 50,
                            userOnly: false
                        },
                        imageUpload: {
                            upload: file => {
                                // return a Promise that resolves in a link to the uploaded image
                                return new Promise((resolve, reject) => {
                                    this.makeUploadFilesForEditor(file, function(res){
                                      resolve(res);
                                    })
                                });
                            }
                        },
                        imageResize: {
                            modules: ["Resize", "DisplaySize", "Toolbar"]
                        }
                    },
                    placeholder: '이곳에 입력해 주세요.',
                },
                options: {
                    format: 'YYYY-MM-DD HH:mm',
                    useCurrent: true,
                    //inline:true,
                    useStrict:true,
                    keyBinds:null,
                    locale: 'ko'
                },
                activity: {
                    title: process.env.NODE_ENV == 'development' ? "test activity": "",
                    thumbnail: "",
                    category: "VOLUNTEER",
                    categorySub: "",
                    volunteerHour:0,
                    volunteerMinute: 0,
                    joinDueDate: moment().format('YYYY-MM-DD HH:mm'),
                    joinTypeAsDepartment: "",
                    joinAblePersonCount: 1,
                    minJoinLimitByAge: 0,
                    maxJoinLimitByAge: 100,
                    minJoinLimitByLevel: 0,
                    maxJoinLimitByLevel: 10,
                    activityStartDate: moment().add(7, 'd').format('YYYY-MM-DD HH:mm'),
                    activityEndDate: moment().add(9, 'd').format('YYYY-MM-DD HH:mm'),
                    activityPlaceName: "",
                    activityPlaceAddress: "",
                    activityJoinCost: 0,
                    activityNotice: "",
                    activityDetails: "",
                    activityCancelPenaltyNotice: "",
                    activityJoinAbleNow: true,
                    visibleAddressToJoinerOnly: false,
                    karaRegularMemberOnly: false,
                    isRepeatableDayOfWeek: false,
                    activityTags: "#KARADOING",
                    activityRegister: "관리자",
                    lat:'',
                    lng:'',
                    isFixedTop: false,
                },
                categorySub: [],
                appKey: '2cc81857a738829d4eb1c2f31d85cf10', //
                center: {'lat':37.55771800694362, lng:126.91377287336415}, // 지도의 중심 좌표
                level: 3, // 지도의 레벨(확대, 축소 정도),
                mapTypeId: VueDaumMap.MapTypeId.NORMAL, // 맵 타입
                libraries: ['services'], // 추가로 불러올 라이브러리
                map: null // 지도 객체. 지도가 로드되면 할당됨.
            };
        },
        methods: {
            onLoad(map) {
                this.map = map

                new kakao.maps.Marker({
                    //position: newCenter,
                    position: map.getCenter(),
                    map: map
                });
            },
            mapCallback(result, status) {
                if (status === kakao.maps.services.Status.OK) {
                    console.log({lat:result[0].y, lng:result[0].x})
                    this.activity.lat=result[0].y;
                    this.activity.lng=result[0].x;
                }
            },
            formSubmit() {
                if(this.activity.volunteerHour > 0)  this.activity.volunteerMinute = parseInt(this.activity.volunteerMinute) + parseInt(this.activity.volunteerHour*60);
                let me = this;
                this.axios.post(process.env.VUE_APP_ADMIN_API_URL + '/activity', this.activity)
                    .then(function (res) {
                        //console.log(res.data.id);
                        me.$router.push({ name: 'activityShow', params: { id: res.data.id }});
                        me.$root.$children[0].commonDialog('활동등록','등록 되었습니다.');
                    }).catch(function (error) {
                    console.log(error);
                    alert('등록 에러');
                });
            },
            deleteActivity() {
                if(confirm("삭제 하시겠습니까?")) {
                    let me = this;
                    this.axios.delete(process.env.VUE_APP_ADMIN_API_URL + '/activity/' + this.$route.params.id, this.activity)
                        .then(function (res) {
                            me.$router.push({name: 'home'});
                            me.$root.$children[0].commonDialog('활동등록', '삭제 되었습니다.');
                        }).catch(function (error) {
                        console.log(error);
                        alert('삭제 에러');
                    });
                }
            },
            onEditorBlur(quill) {
            },
            onEditorFocus(quill) {
            },
            onEditorReady(quill) {
            },
            onEditorChange({quill, html, text}) {
                this.activity.activityDetails = html
            },
            getAddress(addr) {
                this.activity.activityPlaceAddress = addr;
                let geocoder = new kakao.maps.services.Geocoder();
                geocoder.addressSearch(addr, this.mapCallback);
            },
            popupPostcode() {
                this.$modal.show(Postcode,{
                    modal : this.$modal },{
                    width : '330px',
                    height : 'auto',
                    scrollable: true,
                })
            },
            resizeImg(file) {
                let me = this;
                let maxSize = 800;
                let reader = new FileReader();
                let image = new Image();
                let canvas = document.createElement('canvas');
                let dataURItoBlob = function (dataURI) {
                    let bytes = dataURI.split(',')[0].indexOf('base64') >= 0 ?
                        atob(dataURI.split(',')[1]) :
                        unescape(dataURI.split(',')[1]);
                    let max = bytes.length;
                    let ia = new Uint8Array(max);
                    for (let i = 0; i < max; i++)
                        ia[i] = bytes.charCodeAt(i);
                    return new Blob([ia], { type: 'image/jpeg'});
                };
                let resize = function () {
                    let width = image.width;
                    let height = image.height;
                    if (width > height) {
                        if (width > maxSize) {
                            height *= maxSize / width;
                            width = maxSize;
                        }
                    } else {
                        if (height > maxSize) {
                            width *= maxSize / height;
                            height = maxSize;
                        }
                    }
                    canvas.width = width;
                    canvas.height = height;
                    canvas.getContext('2d').drawImage(image, 0, 0, width, height);
                    let dataUrl = canvas.toDataURL('image/jpeg');
                    me.activity.thumbnail = dataUrl

                    me.makeUploadFiles([dataURItoBlob(dataUrl)], function(res){
                        me.activity.thumbnail = res;
                        return res;
                    })
                    return dataURItoBlob(dataUrl);
                };
                return new Promise(function (ok, no) {
                    if (!file.type.match(/image.*/)) {
                        no(me.$root.$children[0].commonDialog('활동 등록', '이미지만 등록가능합니다.'))
                        return;
                    }
                    reader.onload = function (readerEvent) {
                        image.onload = function () { return ok(resize()); };
                        image.src = readerEvent.target.result;

                    };
                    reader.readAsDataURL(file);
                });
            },
            onFileChange(e) {
                const file = e.target.files[0];
                this.resizeImg(file)
            },

            removeImage: function () {
                this.$refs.thumbnail.value = '';
                this.activity.thumbnail = '';
            },
            async makeUploadFiles(files, callback) {
                let formData = new FormData();
                for (let i = 0; i < files.length; ++i) {
                    formData.append('sourceFile', files[i]);
                }
                this.$root.$children[0].uploadFile(formData, 'ACTIVITY').then(callback);
            },

            async makeUploadFilesForEditor(file, callback) {
                let formData = new FormData();
                if(file.size > 5*1024*1024){ // upper than 5MB
                    alert('파일 사이즈가 5MB를 초과합니다. ');
                    return;
                    //file = await this.$root.$children[0].resizeImg(file, 500);
                }
                formData.append('sourceFile', file);
                this.$root.$children[0].uploadFile(formData, 'ACTIVITY').then(callback);
            },

            get() {
                let me = this;
                this.axios.get(process.env.VUE_APP_PUBLIC_API_URL + '/activity/' + this.$route.params.id)
                    .then(function (res) {
                        me.activity = res.data;
                        me.activity.volunteerHour = parseInt((res.data.volunteerMinute / 60))
                        me.activity.volunteerMinute = res.data.volunteerMinute % 60
                        me.applyLeftDays = moment(me.activity.joinDueDate).diff(moment(), 'days') + 1
                    }).catch(function (error) {
                    console.log(error);
                    //alert(' 에러');
                });
            },

            ageCheck() {
                if(this.activity.maxJoinLimitByAge < this.activity.minJoinLimitByAge) {
                    this.$root.$children[0].commonDialog('활동 등록', '나이 상한이 하한보다 클 수 없습니다.');
                    this.activity.minJoinLimitByAge = this.activity.maxJoinLimitByAge;
                    return false;
                }
            },

            levelCheck() {
                if(this.activity.maxJoinLimitByLevel < this.activity.minJoinLimitByLevel) {
                    this.$root.$children[0].commonDialog('활동 등록', '레벨 상한이 하한보다 클 수 없습니다.');
                    this.activity.minJoinLimitByLevel = this.activity.maxJoinLimitByLevel;
                    return false;
                }
            },
            setDefaultAgeToggle() {
                if(this.activity.minJoinLimitByAge == 0 && this.activity.maxJoinLimitByAge == 100 ) {
                    this.activity.minJoinLimitByAge++;
                    this.activity.maxJoinLimitByAge--;
                } else {
                    this.activity.minJoinLimitByAge = 0;
                    this.activity.maxJoinLimitByAge = 100;
                }
            },
            setDefaultLevelToggle() {
                if(this.activity.minJoinLimitByLevel == 0 && this.activity.maxJoinLimitByLevel == 10 ) {
                    this.activity.minJoinLimitByLevel++;
                    this.activity.maxJoinLimitByLevel--;
                } else {
                    this.activity.minJoinLimitByLevel = 0;
                    this.activity.maxJoinLimitByLevel = 10;
                }
            }

        },
        watch: {
            "activity.activityStartDate" : function (val) {
                if(this.activity.activityEndDate < val) {
                    this.$root.$children[0].commonDialog('활동 등록', '시작 날짜가 활동 종료날짜보다 나중일 수 없습니다.');
                    this.activity.activityEndDate = val;
                    return false;
                }
            },
            "activity.activityEndDate" : function (val) {
                if(this.activity.activityStartDate > val) {
                    this.$root.$children[0].commonDialog('활동 등록', '종료 날짜가 활동 시작날짜보다 이전일 수 없습니다.');
                    this.activity.activityEndDate = this.activity.activityStartDate;
                    return false;
                }
            },
            "activity.joinDueDate" : function (val) {

              if(this.activity.activityEndDate < val) {
                    this.$root.$children[0].commonDialog('활동 등록', '접수 마감일이 활동 종료날짜보다 나중일 수 없습니다.');
                    this.activity.joinDueDate = this.activity.activityEndDate;
                    return false;
                }
            },

        },
        mounted() {
            if(this.$route.params.id)
                this.get()
        }
    };
</script>
<style scoped>
    h4 {
        color: red
    }

    .ql-container {
        overflow: auto;
        height: 80%;
    }

    .quill-editor {
        height: 500px;
    }
    .quill-editor .ql-container {
        resize: both;
        overflow-y: scroll;
    }
    .input-group-addon .fa-calendar {
        position: absolute;
        right: 0;
        z-index: -1;
    }
    .input-group.date input {
        width:100%;
        opacity: 0.8;
    }
</style>